<template>
  <div class="m_page">
    <router-view></router-view>
    <div class="prizeEnter">
        <router-link to="/m_prizeinfo">
            <img src="../img/prize.png" alt="" class="">
        </router-link>
    </div>
    <div id="videoPlayWrapper" v-if="showCover"> 
      <div class="tongzhi">
          <div class="closeTongzhi" @click="closeTongzhi()">×</div>
          <img src="../img/m_tongzhi.png" alt="" class="">
      </div>
    </div>
    <!-- <div class="tongzhi">
        <img src="../img/m_tongzhi.png" alt="" class="">
    </div> -->
    <!-- <navbar v-show="isShowBar"></navbar> -->
    <!-- <div class="tip" v-if="tip">
        <div class="tipCon">
          <img src="../img/m_activity_tip.png" alt="">
          <div class="uploadGuide" @click="toHref('m_guide')">
              上传指导
          </div>
          <div class="uploadTip" @click="closeTip()">
              完成
          </div>
        </div>
    </div> -->
    <!-- <div :class="{ 'coverBox': showCover }"></div> -->
  </div>
  
</template>

<script>
import navbar from './common/navbar'
import {mapGetters, mapActions} from 'vuex'

export default {
  components: {
    navbar
  },
  data () {
      return {
          isShowBar: false,
          showCover: true,
          tip: true
      }
  },
  computed: {
    ...mapGetters(['getUserInfo'])
  },
  created() {
      let path = this.$route.path
      // if(path.indexOf('m_notice') > 0 || path.indexOf('m_skilllist') > 0 || path.indexOf('m_prize') > 0) {
      //     this.isShowBar = true
      // } else {
      //     this.isShowBar = false
      // }
      this.checkLogin()
      if(sessionStorage.getItem("tip")) {
        this.tip = false
      }
      //通知
      if(sessionStorage.getItem("showCover")) {
        // this.showCover = false
      }
  },
  methods: {
    ...mapActions(['setUserInfoAction']),
    closeTip() {
      this.tip = false
      sessionStorage.setItem("tip", true)
    },
    //关闭通知
    closeTongzhi(){
      this.showCover = false
      sessionStorage.setItem("showCover", true)
    },
    // 检查登录状态
    checkLogin () {
      this.$utils.get('/user/checkLogin', { withinfo: 1 }).then(res => {
        if (res.code === 1000) {
          this.setUserInfoAction({
            isLogin: true,
            username: res.data.username,
            volunteer_info: res.data.volunteer_info
          })
        } else {
          this.setUserInfoAction({
            isLogin: false,
            username: '',
            volunteer_info: 0
          })
        }
      })
    },
    toHref(url) {
      this.$router.push(url)
      this.tip = false
      sessionStorage.setItem("tip", true)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.m_page {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    position: relative;
    font-family: 'Microsoft YaHei';
    font-size: 0;
    background-image: url(../img/bg.png);
    background-size: 100%;
    background-repeat: repeat;
    .header {
        width: 100%;
        position: relative;
        .banner {
            width: 100%;
        }
        .logo {
            position: absolute;
            bottom: 4%;
            left: 0;
            right: 0;
            margin: auto;
        }
    }
    .tab {
        width: 100%;
        height: 1.6rem;
        background-color: rgba(#fff, 0.7);
        background-image: url(../img/tab_bg.png);
        background-repeat: no-repeat;
        
        .container {
            width: 100%;
            height: 100%;
            margin: auto;
            overflow: hidden;
            a {
                vertical-align: top;
                display: inline-block;
                text-align: center;
                width: 20%;
                height: 1.6rem;
                // line-height: 1.21rem;
                font-size: 0.55rem;
                color: #0b2ab0;
            }
            .cn_name {
                margin-bottom: .1rem;
                margin-top: .2rem;
            }
            .en_name {
                font-size: 0.33rem;
            }
            .router-link-active {
                background-color: #9576ef;
                color: #fff;
            }
        }
    }
    .copyRight {
        // position: absolute;
        bottom: 0px;
        left: 0;
        text-align: center;
        font-size: 20px;
        color: #a38fe9;
        margin-top: 30px;
        padding-bottom: 32px;
        right: 0;
        margin: 30px auto 0;
    }
    .tip {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      margin: auto;
      background-color: rgba(0,0,0,0.7);
      z-index: 10;
      .tipCon {
        width: 90%;
        margin: auto;
        position: absolute;
        top: 5%;
        left: 0;
        right: 0;
        width: 72%;
        margin: auto;
        img {
          width: 100%;
        }
        .uploadGuide {
          position: absolute;
          bottom: 3.2rem;
          font-size: .84rem;
          left: 0;
          color: #4b4df0;
          border-radius: 1rem;
          text-align: center;
          right: 0;
          margin: auto;
          background-color: #ffa913;
          box-shadow: 0px 0px 16px 0px rgba(116, 116, 116, 0.5);
          position: absolute;
          width: 90%;
          height: 1.8rem;
          line-height: 1.8rem;
          cursor: pointer;
        }
        .uploadTip {
          position: absolute;
          bottom: 0.8rem;
          font-size: .84rem;
          left: 0;
          color: #fff;
          border-radius: 1rem;
          text-align: center;
          right: 0;
          margin: auto;
          background-color: rgb(75, 77, 240);
          box-shadow: 0px 0px 16px 0px rgba(116, 116, 116, 0.5);
          position: absolute;
          width: 90%;
          height: 1.8rem;
          line-height: 1.8rem;
          cursor: pointer;
        }
      }
    }
    
    .prizeEnter {
        position: fixed;
        width: 100px;
        bottom: 10%;
        right: 10px;
        z-index: 222;
        img{
          width: 100%;
        }
    }
    #videoPlayWrapper {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 999;
        .tongzhi{
          width: 80%;
          margin-left: 10%;
          margin-top: 5rem;
          .closeTongzhi{
            position: absolute;
            background-image: url(../img/m_tongzhi_x.png);
            width: 24px;
            height: 25px;
            margin-top: 8px;
            right: 13%;
          }
          img{
            width: 100%;
          }
        }

    }
    
}
.coverBox{
    position: absolute;
    width:100%;
    height: 100%;
    background-color: #000000;
  }


</style>
